'use client';

import { useEffect, useState } from 'react';
import { usePathname } from 'next/navigation';
import { signOut } from 'next-auth/react';
import { useRouteGuard } from '@/hooks/useRouteGuard';
import { isJwtExpired } from '@/utils/tokenExpiry';
import SubscriptionLockGate from '@/app/shared/SubscriptionLockGate';

export default function RouteGuardWrapper({
  children,
}: {
  children: React.ReactNode;
}) {
  useRouteGuard();
  // The API token (1 day) expires long before the NextAuth session (30 days). Check it up front so an
  // expired login goes straight to /signin instead of flashing an empty dashboard whose first request 401s.
  const pathname = usePathname() || '';
  const isPublic = /^\/(signin|auth|access-denied|coming-soon|maintenance)(\/|$)/.test(pathname);
  const [state, setState] = useState<'checking' | 'ok' | 'expired'>('checking');

  useEffect(() => {
    if (isPublic) return;
    let token: string | null = null;
    try {
      token = localStorage.getItem('userToken');
    } catch {}
    if (isJwtExpired(token)) {
      setState('expired');
      try {
        localStorage.removeItem('userToken');
      } catch {}
      signOut({ callbackUrl: `${window.location.origin}/signin` });
    } else {
      setState('ok');
    }
  }, [isPublic]);

  if (!isPublic && state !== 'ok') return null;
  return <SubscriptionLockGate isPublic={isPublic}>{children}</SubscriptionLockGate>;
}
